import React from 'react';

/* A note when using this component - if you not pass a fill color the icon will use the default fill color. */

const IconInstagramVerifiedBadge = props => (
  <svg data-dir="ltr" viewBox="0 0 16 16" {...props}>
    <title>Instagram Verified Badge Icon</title>
    <g>
      <path
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeDashoffset: 0,
          strokeLinejoin: 'miter',
          strokeMiterlimit: 4,
          fill: !props.fill ? '#42a5f5' : props.fill,
          fillRule: 'nonzero',
          opacity: 1,
        }}
        d="m5.62-21 3.43 5.31 6.32.31.32 6.32L21-5.63 18.12 0 21 5.62l-5.31 3.43-.31 6.32-6.32.32L5.63 21 0 18.12-5.62 21l-3.43-5.31-6.32-.31-.32-6.32L-21 5.63-18.12 0-21-5.62l5.31-3.43.31-6.32 6.32-.32L-5.63-21 0-18.12z"
        transform="matrix(.42 0 0 .42 8 8)"
      />
      <path
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeDashoffset: 0,
          strokeLinejoin: 'miter',
          strokeMiterlimit: 4,
          fill: '#fff',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        d="M-2.6 6.74-9.09.25l2.12-2.12 4.41 4.4L7-6.74l2.09 2.15z"
        transform="matrix(.42 0 0 .42 7.996 8.214)"
      />
    </g>
  </svg>
);

export default IconInstagramVerifiedBadge;
